<template>
  <div class="goods-pay-page">
    <div class="introduce">
      <div class="item">
        <div class="title">
          <div class="title-l">1.二代免插卡ETC<img class="icon" src="https://wecos.etczs.net/H5/newApply/wxPay-logo-green.png" alt=""></div>
          <div class="title-r"><span class="text">价值</span><span class="fee">180元</span></div>
        </div>
        <div class="obu-card">
          <img src="https://wecos.etczs.net/H5/newApply/obu-mingchuang.png" alt="">
          <div class="add" >+</div>
          <img src="https://wecos.etczs.net/H5/newApply/h5-warfare.png" alt="">

        </div>
      </div>
      <div class="line"></div>
      <div class="item">
        <div class="title">
          <div class="title-l">2.路费补贴礼包 <img class="icon second" src="https://wecos.etczs.net/H5/newApply/tip-new-xianshizeng.png" alt="" ></div>
          <div class="title-r"><span class="text">价值</span><span class="fee">180元</span></div>
        </div>
        <div class="tip">连续12个月，每月可任领1张优惠券</div>
        <img class="coupon-big" src="https://wecos.etczs.net/H5/newApply/h5-coupon-big-new.png">
        <div class="tip other">连续12个月，每月可任领1张优惠券</div>

        <div class="coupon-con">
          <img class="coupon-item" src="https://wecos.etczs.net/H5/newApply/coupon-item-wash.png">
          <img class="coupon-item" src="https://wecos.etczs.net/H5/newApply/coupon-item-oil.png">

        </div>
      </div>
    </div>
    <div class="bottom-wrap">
      <div class="agreement-box">
        <div class="check-wrap" @click="agreeProtocol = !agreeProtocol">
          <i class="iconfont" :class="agreeProtocol?'etc-icon-checked':'etc-icon-uncheck'"></i>
        </div>
        <div class="agreement">
          <span>已阅读并同意</span>
          <span color-blue @click="goProtocol('USER_SERVE_PROTOCOL')">用户服务协议</span>
          <span>及</span><span color-blue @click="goProtocol('OBU_USE_PROTOCOL')">使用协议</span>
        </div>
      </div>
      <div class="btn-wrap">
        <button class="cool-btn has-tip" @click="showPayTip">￥180 开通权益卡</button>
      </div>
    </div>
    <div class="mask" @click="showPopup = !showPopup" v-if="showPopup"></div>
    <div class="tip-popup" :class="showPopup ? 'show': ''">
      <div class="title">
        <img @click="showPopup = !showPopup" src="https://wecos-1259440055.cos.ap-shanghai.myqcloud.com/piaogen/assets/images_v2/icon-close.png" alt="" class="close">
        办理须知
      </div>
      <div class="bold">办理ETC需符合以下条件：</div>
      <div class="normal">1、非出租车、货车、公司车、专项作业车、公务车办理</div>
      <div class="normal">2、持有车辆（<span class="plate">{{applyOrderInfo.plate_no}}</span>）行驶证和车主身份证原件，激活前需拍照上传</div>
      <div class="yellow">设备发货后因个人原因取消办理，需由你退回设备并承担运费。</div>
      <div class="popup-agree">
        <div class="check-wrap" @click="popupAgree = !popupAgree">
          <i class="iconfont" :class="popupAgree?'etc-icon-checked':'etc-icon-uncheck'"></i>
        </div>
        <div>已知道并同意以上条款</div>

      </div>
        <button class="cool-btn" @click="apply">确认</button>

    </div>
  </div>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
import BiMixin from '@/mixins/biMixin'
// api
// import NewApplyApi from '@/api/newApply.api'
import SystemApi from '@/api/system.api'
import reconApply from '@/api/reconApply.api'

// config
import ETC from '@/config/etc.config'
// store
import { mapState, mapMutations } from 'vuex'
// components

let customData = {
  isAndroid: ''
}

export default {
  name: 'goodsPay',
  mixins: [FunMixin, BiMixin],
  components: {
  },
  data() {
    return {
      showHide: true,
      openTips: { '4': false, '2': false, '99': false, bzj: true },
      agreeProtocol: true,
      showPopup: false,
      popupAgree: false,
      currentProduct: {
        package_sn: 'CarPackage00313'
      }
    }
  },
  computed: {
    ...mapState([
      'newApplyInfo',
      'gdtInfo',
      'currentCard',
      'currentOrder',
      'applyOrderInfo'
    ])
  },
  methods: {
    goProtocol(protocolName) {
      if (
        protocolName === 'OBU_USE_PROTOCOL' &&
        this.currentCard.card_type === 2
      ) {
        // 如果是储值卡则跳储值卡协议
        protocolName = 'RECHARGE_OBU_USE_PROTOCOL'
      }
      this.m_goPagesWithQ('agreement', { agreementType: protocolName })
    },
    showPayPop() {
      this.m_showConfirm({
        content: '请确认是否已支付完成',
        cancelBtn: '未支付',
        confirmBtn: '已支付'
      }).then(res => {
        if (!res) {
          localStorage.setItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD, '')
        }
        this.m_backHome()
      })
    },
    showPayTip() {
      if (!this.agreeProtocol) {
        return this.m_showToast('您还没有同意服务协议')
      }
      this.showPopup = true
    },
    async apply() {
      if (!this.popupAgree) {
        return this.m_showToast('您还没有同意以上条款')
      }
      this.m_showLoading()
      this.biLog({ eventID: 2002101 })
      try {
        // 腾讯系广告
        if (this.appChannel === 'tencent') {
          await SystemApi.adActions(this.gdtInfo)
        }
        const creatOrderRes = await reconApply.orderSubmitOrder({
          card_id: 0,
          ...this.applyOrderInfo,
          scene: 8,
          purchase_type: 16,
          purchase_party: 0,
          term: 3,
          package_sn: this.currentProduct.package_sn // h5申办写死产品包
        })
        const res = await reconApply.applyPurchase({
          purchase_type: 16,
          purchase_party: 0,
          order_sn: creatOrderRes.order_sn,
          is_h5: 1,
          term: 3

        })
        console.log('=======', res.payment_info)
        if (res.payment_info) {
          localStorage.setItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD, 'yes')
          let channel = localStorage.getItem(
            ETC.LOCAL_STORAGE_KEY.APP_FROM_CHANNEL
          )
          console.log('----', channel)
          let domain = document.domain
          console.log('=====', domain)
          if (channel === 'kuaigou' && customData.isAndroid) {
            window.suyun.setExtraInfoHead('Referer', 'https://' + domain)
          }
          await this.m_awaitTime(200)
          console.log('+++++', this.appChannel)
          if (this.appChannel === 'tencent') {
            // card type ; order_sn
            location.href =
              res.payment_info.mweb_url +
              `&redirect_url=https%3A%2F%2F${domain}/paySuccess%3Fchannel%3D${channel}%26cardType%3D${this.currentCard.card_type}%26orderSn%3D${this.currentOrder.order_sn}%26plateNo%3D${this.newApplyInfo.plate_no}`
          } else {
            location.href =
              res.payment_info.mweb_url +
              `&redirect_url=https%3A%2F%2F${domain}/payBack%3Fchannel%3D${channel}`
          }
          // location.href = res.payment_info.mweb_url + '&redirect_url=' + ETC.ETC_URL + '%3Fchannel%3D' + localStorage.getItem(ETC.LOCAL_STORAGE_KEY.APP_FROM_CHANNEL)
        } else if (+res.need_pay === 0) {
          localStorage.setItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD, 'yes')
          this.setUserApplyStep(5)
          this.m_backHome()
        }
      } catch (e) {
        console.log('errrrrr', e)
      } finally {
        this.m_loadingClose()
      }
    },
    ...mapMutations(['setUserApplyStep'])
  },
  async mounted() {
    customData.isAndroid = await this.m_isAndroid()
    // 如果支付状态存在
    if (localStorage.getItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD) === 'yes') {
      this.showPayPop()
    }
    console.log(this.currentOrder)
    reconApply.applyGetProductList({
      promotion: 9
    })
      .then(res => {
        this.currentProduct = res.products[0]
      })
  }
}
</script>

<style scoped lang="scss">
@import '../../style/cool.practical';
.goods-pay-page {
  box-sizing: border-box;
  padding: 40px 40px 32px;
  padding-bottom: 32px;
  .introduce {
    .title {
     &-l {
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 48px;
      .icon {
        margin-left: 20px;
        width: 128px;
        height: 36px;
        &.second {
          margin-left: 56px;
          width: 98px;
          height: 40px;
        }
      }
      @extend %flex-align-center
     }
     &-r {

      .text {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 36px;
      }
      .fee {

        margin-left: 4px;

        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #6B4B39;
        line-height: 48px;
      }
      @extend %flex-align-center
     }
     @extend %flex-space-between
    }
    .obu-card {
      display: flex;
      align-items: center;
      img {
        width: 180px;
        height: 180px;
        display: block;
      }
      .add {
        color: #999999;
        font-size: 30px;
        font-weight: bold;
      }
      width: 359px;
      height: 105px;
      margin-top: 29px;
    }
    .line {
      width: 670px;
      height: 2px;
      background: #EEEEEE;
      margin-top: 40px;
      margin-bottom: 40px;
    }
    .tip {

      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 42px;
      margin-bottom: 28px;
      &.other {
        margin-top: 28px;
        margin-bottom: 16px;
        color: #A06D3D;
      }
    }
    .coupon-one {
      display: block;
      width: 686px;
      height: 168px;
    }
    .coupon-big {
      display: block;
      width: 686px;
      height: 168px;
    }
    .coupon-con {
      display: flex;
      justify-content: space-between;
      .coupon-item {
        display: block;
        width: 320px;
        height: 160px;
      }
    }
  }
}
.bottom-wrap{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 30px;
    .btn-wrap{
      padding: 15px 55px 0;
    }
  }
  .agreement-box{
    margin-left: 10px;
    padding: 10px 0 0;
    @extend %flex-center;
    .check-wrap{
      padding: 20px;
      display: flex;
      align-self: flex-start;
      .iconfont{
        font-size: 36px;
        // border-radius: 10px;
        background-color: #fff;
      }
      .etc-icon-uncheck{
        color: #cccccc;
      }
      .etc-icon-checked{
        color: $primary-color;
      }
    }
    .agreement{
      font-size: 26px;
      color: #333333;
    }
  }
  .cool-btn {
    width: 640px;
    height: 88px;
    background: #0ED49B !important;
    border-radius: 46px;
    position: relative;
    box-shadow: none;
    &.has-tip::after {
      display: block;
      content: '价值最高360';

      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #AD751A;
      line-height: 48px;
      width: 186px;
      height: 48px;
      background: #FFEA6A;
      border-radius: 24px 24px 24px 0px;
      position: absolute;
      right: 0;
      top: -17px;
    }
  }
  .mask {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: #000000;
    opacity: 0.5;
    top: 0;
    left: 0;
  }
  .tip-popup {
    overflow: hidden;
    position: fixed;
    left: 0;
    height: 0;
    bottom: -739px;
    width: 750px;
    box-sizing: border-box;
    background: #FFFFFF;
    border-radius: 32px 32px 0px 0px;
    padding: 40px;
    padding-bottom: 32px;
    transition: all 0.3s;
    &.show {
      height: 739px;
      bottom: 0;
    }
    .title {
      text-align: center;
      position: relative;
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 54px;
      .close {
        width: 50px;
        height: 50px;
        position: absolute;
        top: -3px;
        left: 0;
      }
    }
    .bold {
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 48px;
      margin-top: 40px;
      margin-bottom: 24px;
    }
    .normal {
      margin-bottom: 20px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 42px;
      &:last-child {
        margin-bottom: 0;
      }
      .plate {
        font-family: PingFangSC-Medium, PingFang SC;
      color: #333333;

      }
    }
    .yellow {
      margin-top: 36px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFBB1D;
      line-height: 42px;
    }
    .popup-agree {
      @extend %flex-center;
      margin-top: 30px;
      .check-wrap {
        padding: 10px;
        .etc-icon-uncheck{
        color: #cccccc;
      }
      .etc-icon-checked{
        color: $primary-color;
      }
      }
    }
    .cool-btn {
      margin-top: 14px;
    }
  }
</style>
